import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetPerennialCroplandQuery,
  usePublicGetPerennialCroplandQuery,
  useGetPerennialCroplandDefaultsQuery,
  usePublicGetPerennialCroplandDefaultsQuery,
  useUpdatePerennialCroplandMutation
} from '../features/modules/perennialCroplandApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting perennial cropland data based on the current route.
 */
export const useContextAwareGetPerennialCropland = createContextAwareHook(
  useGetPerennialCroplandQuery,
  usePublicGetPerennialCroplandQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting perennial cropland defaults based on the current route.
 */
export const useContextAwareGetPerennialCroplandDefaults = createContextAwareHook(
  useGetPerennialCroplandDefaultsQuery,
  usePublicGetPerennialCroplandDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdatePerennialCroplandMutation
}; 